import { combineReducers } from "redux";
import { Reducers } from "interface/sharedJsInterface";

export default combineReducers(Reducers);
